import React from 'react'

/** Раздел всплывашки с подзаголовком. */
export const DetailSection: React.FC<{ title: string; children: React.ReactNode }> = ({
  title,
  children,
}) => (
  <div className='pt-2 mt-2 border-top border-gray-200'>
    <div
      className='text-muted text-uppercase fw-bold mb-1'
      style={{ fontSize: 9, letterSpacing: '0.04em' }}
    >
      {title}
    </div>
    <div className='d-grid gap-1' style={{ gridTemplateColumns: 'auto 1fr', columnGap: 12 }}>
      {children}
    </div>
  </div>
)

/** Строка «подпись — значение» внутри раздела. */
export const DetailRow: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <>
    <span className='text-muted text-nowrap'>{label}</span>
    <span className='fw-semibold text-break text-end'>{children}</span>
  </>
)

/** Полоса заполнения: оплачено и ещё в работе поверх суммы. */
export const FillBar: React.FC<{
  total: number
  paid: number
  live: number
  paidColor: string
  liveColor: string
}> = ({ total, paid, live, paidColor, liveColor }) => {
  const pct = (v: number) => `${Math.max(0, Math.min(100, total > 0 ? (v / total) * 100 : 0))}%`
  return (
    <div
      className='d-flex rounded overflow-hidden bg-gray-200 my-1'
      style={{ height: 6, gridColumn: '1 / -1' }}
    >
      <div style={{ width: pct(paid), background: paidColor }} />
      <div style={{ width: pct(Math.max(0, live - paid)), background: liveColor }} />
    </div>
  )
}
